import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RadioButtonControl } from '../../../form-models/radio-button-control';

@Component({
  selector: 'hb-dynamic-radio-button',
  templateUrl: './dynamic-radio-button.component.html',
  styleUrls: ['./dynamic-radio-button.component.scss'],
})
export class DynamicRadioButtonComponent implements OnInit {
  @Input() control: RadioButtonControl;
  @Input() formGroup: FormGroup;

  @Output() onOverrideValue = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
